import { render } from "./NotaryJournal.vue?vue&type=template&id=302cbf03&scoped=true"
import script from "./NotaryJournal.vue?vue&type=script&lang=js"
export * from "./NotaryJournal.vue?vue&type=script&lang=js"

import "./NotaryJournal.vue?vue&type=style&index=0&id=302cbf03&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-302cbf03"]])

export default __exports__